import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const eocGlobalAlertsDetailRoute: InvariantJiraRoute = {
	name: 'eoc-global-alert-detail',
	path: '/jira/ops/alerts/:id',
	exact: true,
};
